import React, { useState, useRef, useEffect } from "react";
import Cropper from "react-easy-crop";
import { Point, Area } from "react-easy-crop/types";
import { useSelector } from 'react-redux/es/hooks/useSelector';
import getCroppedImg from "./cropImage";
import ModalBase from "./ModalBase";
import { useDispatch } from "react-redux";
import systemSlice from "../../../../redux/systemSlice";
import PrimaryButton from "../../PrimaryButton";
import SecondaryButton from "../../SecondaryButton";
import { imageScaler } from "../../../../helper/ImageScaler";
function ImageCropper() {
    const { id, aspectRatio, image, boxWidth, boxHeight, type, croppedImageProps: initialCroppedImageProps } = useSelector((state: any) => state.systemSlice.imageCropperSettings);

    const dispatch = useDispatch()

    const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedImage, setCroppedImage] = useState<any>()
    const [croppedImageProps, setCroppedImageProps] = useState<any>()

    const onCropComplete = async (croppedArea: Area, croppedAreaPixels: Area) => {
        const croppedImage = await getCroppedImg(image, croppedAreaPixels)
        setCroppedImage(croppedImage)
        setCroppedImageProps({ croppedAreaPixels, zoom })
    };
    const closeModal = () => {
        dispatch(systemSlice.actions.setImageCropperSettings({ image: "" }))
    }
    const saveImage = async () => {
        const croppedImageObject: any = {}
        const sizedCroppedImage = await imageScaler(croppedImage, type, boxWidth, boxHeight)
        croppedImageObject[id] = { image: sizedCroppedImage, croppedImageProps }
        dispatch(systemSlice.actions.setCroppedImages(croppedImageObject))
        closeModal()
    }
    useEffect(() => {
        setZoom(initialCroppedImageProps?.zoom || 1)
    }, [id])
    console.log(boxWidth, boxHeight)
    return (
        <>
            {image &&
                <div className={`appear fixed inset-0 overflow-y-visible flex flex-col p-5 items-center top-0 left-0 z-[100]`}>
                    <div className='shadow' ></div>
                    <div className="bg-white p-8 w-[90%] md:w-[60%] xl:w-[600px] z-[500] overflow-visible h-auto m-auto rounded-2xl">
                        <>
                            <div className="w-full h-[400px] relative" style={{ aspectRatio: aspectRatio }}>
                                <Cropper
                                    initialCroppedAreaPixels={initialCroppedImageProps?.croppedAreaPixels}
                                    image={image}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={aspectRatio}
                                    onCropChange={setCrop}
                                    onCropComplete={onCropComplete}
                                    onZoomChange={setZoom}
                                />

                            </div>
                            <div className="flex flex-row w-full items-center justify-end gap-[15px] py-4">
                                <SecondaryButton onClick={closeModal} value={"goBack"}></SecondaryButton>
                                <PrimaryButton onClick={saveImage} value={"confirmCrop"}></PrimaryButton>
                            </div>
                        </>
                    </div>
                </div>

            }
        </>

    );
}

export default ImageCropper

